import { Modal, Table } from 'antd';
import Column from 'antd/es/table/Column';
import Ellipse from 'components/Global/Ellipse';

import { formatDate, invalidText } from 'utils/utils';

import { CloseOutlined } from '@ant-design/icons';
import Title from 'antd/es/typography/Title';
import DownloadComponent from 'components/Global/Download';
import { useSelector } from 'react-redux';
import EmployeeShareComponent from '../ToolTip';
import './index.scss';

type HistoryProps = {
	open: boolean;
	closeModal: () => void;
	totalRecords: number;
	currentPage: number;
	pageSize: number;
	tableChangeHandler: (pagination: any, filter: any, sorter: any) => void;
	allPayeDetails: any;
	isLoading: boolean;
};
const HistoryModal = (props: HistoryProps) => {
	const {
		open,
		closeModal,
		totalRecords,
		currentPage,
		pageSize,
		tableChangeHandler,
		allPayeDetails,
		isLoading,
	} = props;

	const { data: profileData } = useSelector(
		(state: any) => state?.userProfile
	);

	return (
		<Modal
			maskClosable={true}
			open={open}
			width={1000}
			closable={false}
			footer={null}
			rootClassName="payeModalRoot"
		>
			<div className="modal-header">
				<Title level={4} className="modal-title">
					History
				</Title>
				<div className="close-icon" onClick={closeModal}>
					<CloseOutlined />
				</div>
			</div>
			<Table
				dataSource={allPayeDetails}
				pagination={{
					total: totalRecords,
					current: currentPage,
					pageSize: pageSize,
					showSizeChanger: false,

					pageSizeOptions: [10, 20, 50, 100, 200],
				}}
				onChange={tableChangeHandler}
				rowKey={(record) => record?.id}
				loading={isLoading}
			>
				<Column
					title="Updated By"
					dataIndex="createdBy"
					key="createdBy"
					className="bg-white"
					render={(text) => text.fullName}
				/>
				<Column
					title="Effective Date"
					dataIndex="effectiveDate"
					key="effectiveDate"
					sorter={true}
					className="bg-white"
					render={(value) => {
						return formatDate(
							value,
							profileData?.companyDateFormat ?? 'DD/MM/YYYY'
						);
					}}
				/>

				<Column
					title="Notes"
					dataIndex="notes"
					key="notes"
					sorter={true}
					className="bg-white"
					render={(text, record: { id: string }) =>
						invalidText(text) ? (
							'-'
						) : (
							<Ellipse
								message={text}
								maxLength={20}
								key={record.id}
								tooltipMessage={text}
								isTooltip={true}
							/>
						)
					}
				/>

				<Column
					title="Attachment"
					dataIndex="attachment"
					key="attachment"
					className="bg-white"
					render={(text, record: any) => (
						<div>
							{record?.documentName ? (
								<div>
									<DownloadComponent
										documentUrl={record.documentUrl}
										showTooltip={true}
										downloadText={record.documentName}
										text={record.documentName}
										isLink={true}
										maxLength={20}
									/>
								</div>
							) : (
								'-'
							)}
						</div>
					)}
				/>
				<Column
					title="Employee Share"
					dataIndex="PAYEEmployeeShare"
					key="PAYEEmployeeShare"
					className="bg-white"
					render={(employeeShare) => (
						<EmployeeShareComponent employeeShare={employeeShare} />
					)}
				/>
			</Table>
		</Modal>
	);
};

export default HistoryModal;
